<div class="spinner">
  <div class="rect1"></div>
  <div class="rect2"></div>
  <div class="rect3"></div>
  <div class="rect4"></div>
  <div class="rect5"></div>
</div>

<div class="center">
  <p>{{waitingMessage}}</p>
  <div class="col-12" *ngIf="activeRequest && activeRequest.cancellable">
    <button pButton type="button" (click)="cancel()" [label]="'COMMON.CANCEL' | translate" class="p-button-danger"></button>
  </div>

</div>



